import React from 'react'
import './About.css'


function About() {

    return (
        <div className="container component-space" id="about">
            <div className=" about-parent">
                <div className=" row about-details">

                    <div className="col-md-10 offset-md-1 col-xs-10 offset-xs-1">
                        <h1 className="about-name">
                            About Me
                        </h1>
                        <p className="text-intro">
                            Hey there, I am <b>Mumbere N. Arnold. </b><br />
                            I am a <b>Software Developer</b> with years of experience that have worked with different technologies and environments.
                            Experienced with back-end as well as front-end development,
                            I am a professional passionate about creating technology solutions and bringing amazing designs to life.
                        </p>
                        <div className="about-meta">
                            <h3 className="text-title"><i className="fa fa-graduation-cap"></i>Education</h3>
                            <p className="offset-3 border-5 border-left border-success pl-3 about-text p-color">
                                <h4 className="about-text-ed">international university of east africa</h4>
                                <i>2015-2018</i><br /><br /><br /><br /><br />
                                <b>Bachelor of Science in Computer Science (B.Sc. CS)</b><br />
                                <a
                                    href="https://iuea.ac.ug/Graduation/sitepad-data/uploads//2020/11/5th-Graduation-29th-Nov.-2018.pdf"
                                    target="_blank
                                ">iuea.ac.ug
                                </a><br /><br />
                                <h4 className="about-text-ed">Graffins college</h4><i>2012-2013</i><br /><br /><br /><br /><br />
                                <b>Business information technology (BIT)</b>
                            </p>
                            <h3 className="text-title"><i className="fa fa-briefcase"></i>Experience</h3>
                            <p className="offset-3 border-5 border-left pl-3 about__text p__color">
                                <h5 className="about-text-experience">freelancer</h5>
                                <i>2019-present</i><br /><br /><br /><br /><br />
                                <b>Swahili Spaces/ Self Employed</b><br />
                                Doing
                                translations for companies that require people with fluency in more than one
                                international language mostly English and French.
                            </p>
                            <p className="offset-3 border-5 border-left pl-3 about__text p__color">
                                <h5 className="about-text-experience">android developer</h5>
                                <i>2018-2019</i><br /><br /><br /><br /><br />
                                <b>Scintillam Labs</b><br />


                            </p>
                            <p className="offset-3 border-5 border-left pl-3 about__text p__color">
                                <h5 className="about-text-experience">full stack developer</h5>
                                <i>2019-present</i><br /><br /><br /><br /><br />
                                <b>Self Employed</b><br />
                                Developing web appplications for clients that require my skills and helping them manage
                                these websites. Working with various companies as a software analyst for their
                                businesses and showing them the need of technology in their business.e

                            </p>
                            <p className="offset-3 border-5 border-left  pl-3 about__text p__color">
                                <h5 className="about-text-experience">Online Researcher</h5>
                                <i>Aug 2012 – Feb 2013</i><br /><br /><br /><br /><br />
                                <b>Digital Divide Data Kenya</b><br />
                                Research on bribes and kickbacks in french speaking countries in the African
                                continent and then after translate them to whole case into English by including the
                                people involved and the major corporations. Entering data into the local database
                                which was used by the time (ms Excel). Analyzing data and upload to them main
                                server.
                            </p>
                            <h3 className="text-title"><i className="fa fa-cogs"></i>Tech stack</h3>
                            <p className="offset-3 border-5 border-left border-primary pl-3 about__text p__color">
                                <ul className="tech-text">
                                    <li>Android (Mobile)</li> <br />
                                    <li> Javascript (Front end and back end)</li> <br />
                                    <li>Kotlin (Android)</li> <br />
                                    <li>Flutter (Full stack)</li> <br />
                                    <li>Crossplatform (React.js)</li><br />
                                    <li>Web3/Solidity (React.js)</li>
                                </ul>
                            </p>
                        </div>

                    </div>

                </div>
            </div>
        </div >

    );
}

export default About;
